module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAUCAIAAACvapLzAAAArElEQVRIx2P4TzT4/fPX1f0nVlT3VpsH5Sra0xox/CcFfHn38dT6XfOy6/NVHAeRy75//rJ94oIOryQ6BBjJYQYErx48Wds0edCF2ZrGSQVqLoM0zL59/DwYw2xdy9RKY//BGGZ///y5dfz88qqeQRdmR5ZunJFUXqTpNujC7MXtB7umL+0NysxTchh12VCPzcGbAwZvqTF4S9pBXTsN0hp98LaCBmnLkc6tbQA6Pf42FXBMYwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/qa.png
// module id = 909
// module chunks = 0